<template>
  <div class="home" style="height:100%">
    <a-layout id="components-layout-demo-fixed-sider" >
      <a-layout-sider :style="{ overflow: 'auto', height: '100%', position: 'fixed', left: 0,top:0,zIndex:20,}" v-model="collapsed" :trigger="null" collapsible>
        <div class="logo" style="height:64px">
          <img style="width: 42px;height: auto;" src="/static/logo1.png" alt="">
          <div style="display:inline-block;">
            <img style="width: 92px;height: auto;" src="../../static/logo-text.png" alt="">
          </div>
        </div>
          <a-menu
            :openKeys="openKeys"
            mode="inline"
            @openChange="onOpenChange" 
            :defaultSelectedKeys="defaultSelectedKeys"
            theme="dark"
            :inline-collapsed="collapsed"
          >
          <template v-for="item in menulist">
            <!-- {{item.child[0]}} -->
            <a-menu-item v-if="item.child.length==0" :key="item.id">
              <router-link  :to="item.route">
                <a-icon :type="item.icon" />
                <span>{{ item.name }}</span>
              </router-link>
            </a-menu-item>

             <a-sub-menu v-else :key="item.id">
                <span slot="title"><a-icon type="mail" /><span>{{ item.name }}</span></span>
                <a-menu-item :key="second.id" v-for="second in item.child">
          
                  <router-link :to="second.route">
                    {{ second.name }}
                  </router-link>
                </a-menu-item>
                <!-- <a-menu-item key="6">
                  <router-link to="/home/push" >
                    推送商机
                  </router-link>
                </a-menu-item> -->
              </a-sub-menu>
            <!-- <sub-menu v-else :menu-info="item" :key="item.key" /> -->
          </template>

        <!-- <a-menu-item key="1">
          <router-link  to="/home/main">
            <span><a-icon type="home" /><span>首页</span> </span>
          </router-link>
        </a-menu-item>

        <a-menu-item key="2">
          <router-link to="/home/analysis" >
            <a-icon type="pie-chart" />
            <span>效果分析</span>
          </router-link>
        </a-menu-item>

        <a-sub-menu key="sub1">
          <span slot="title"><a-icon type="mail" /><span>询盘信息</span></span>
          <a-menu-item key="5">
            <router-link to="/home/inquiry">
              自有询盘
            </router-link>
          </a-menu-item>
          <a-menu-item key="6">
            <router-link to="/home/push" >
              推送商机
            </router-link>
          </a-menu-item>
        </a-sub-menu>

        <a-sub-menu key="sub2">
          <span slot="title"><a-icon type="appstore" /><span>排名查询</span></span>
          <a-menu-item key="9">
            <router-link to="/home/nranking" >
            自然排名
            </router-link>
          </a-menu-item>
          <a-menu-item key="10">
            <router-link to="/home/airanking" >
            AI快排
            </router-link>
          </a-menu-item>
          <a-menu-item key="11">
            <router-link to="/home/paid" >
            付费引流
            </router-link>
          </a-menu-item>
        </a-sub-menu>
        <a-sub-menu key="sub3">
          <span slot="title"><a-icon type="appstore" /><span>系统管理</span></span>
          <a-menu-item key="12">
            <router-link to="/home/account" >
            账号信息
            </router-link>
          </a-menu-item>
          <a-menu-item key="13">
            <router-link to="/home/recharge" >
            充值明细
            </router-link>
          </a-menu-item>
          <a-menu-item key="14">
            <router-link to="/home/bwlist" >
            黑白名单
            </router-link>
          </a-menu-item>
          <a-menu-item key="15">
            <router-link to="/home/message" >
            消息公告
            </router-link>
          </a-menu-item>
           <a-menu-item key="25">
            <router-link to="/home/statistics" >
            统计代码
            </router-link>
          </a-menu-item>
          <a-menu-item key="16">
            <router-link to="/home/service" >
            开通服务
            </router-link>
          </a-menu-item>
        </a-sub-menu>

        <a-sub-menu key="sub4">
          <span slot="title"><a-icon type="mail" /><span>流量管理</span></span>
          <a-menu-item key="19">
            <router-link to="/home/flowtype">
              流量类型
            </router-link>
          </a-menu-item>
          <a-menu-item key="20">
            <router-link to="/home/flowsource" >
              流量来源
            </router-link>
          </a-menu-item>
        </a-sub-menu>

        <a-menu-item key="17">
          <router-link  to="/home/menu">
            <span><a-icon type="menu" /><span>菜单管理</span> </span>
          </router-link>
        </a-menu-item>
        <a-menu-item key="18">
          <router-link  to="/home/role">
            <span><a-icon type="team" /><span>角色管理</span> </span>
          </router-link>
        </a-menu-item>

        <a-sub-menu key="sub5">
          <span slot="title"><a-icon type="user" /><span>会员管理</span></span>
          <a-menu-item key="21">
            <router-link to="/home/user">
              用户管理
            </router-link>
          </a-menu-item>
          <a-menu-item key="22">
            <router-link to="/home/staff" >
              员工管理
            </router-link>
          </a-menu-item>
        </a-sub-menu> -->

        <!-- <a-menu-item key="20">
          <router-link  to="/user">
            <span><a-icon type="user" /><span>用户管理</span> </span>
          </router-link>
        </a-menu-item> -->
      </a-menu>
      </a-layout-sider >
      <a-layout :style="{ paddingLeft: left1}">
        <a-layout-header :style="{ width:'100%',zIndex:9, paddingLeft: left2,background:'#fff', position: 'fixed', right: 0,top:0 }">
          <span>
          <a-icon
            class="trigger"
            :type="collapsed ? 'menu-unfold' : 'menu-fold'"
            @click="chang()"
            style="font-size: 20px"
          />
           <span style="vertical-align: 2px;">助力企业打造自主电商营销系统</span>
          </span>

          <div class="top-account-info">
            <router-link  to="/home/message" style="padding:0 30px">
              <a-badge dot >
                <a-icon type="bell" style="color: rgba(0,0,0,.65);font-size: 18px;padding:0 4px"/>
              </a-badge>
            </router-link>

            <a-dropdown>
              <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                <a-icon type="user" style="color: rgba(0,0,0,.65);font-size:16px;padding-left:12px"/>
                <span>{{userinfo.company}}</span>
              </a>

              <a-menu slot="overlay">
                <a-menu-item key="1">
                  <router-link to="/home/main" >
                  <a-icon type="home" />
                  进入官网
                  </router-link>
                </a-menu-item>
                <a-menu-item key="2">
                  <router-link to="/home/main" >
                  <a-icon type="cluster" />
                  进入WXCMS后台
                  </router-link>
                </a-menu-item>
                <a-menu-item key="3">
                  <router-link to="/home/inquiry" >
                    <a-icon type="home" />
                    我的询盘
                  </router-link>
                </a-menu-item>
                <a-menu-item key="4">
                  <router-link to="/home/account/base" >
                    <a-icon type="snippets" />
                    账户信息
                  </router-link>
                </a-menu-item>
                 <a-divider style="margin:6px 0"/>
                <a-menu-item key="5" class="login-out">
                  <router-link to="/" >
                    <a-icon type="logout" />  
                    退出登录
                  </router-link>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </div>


        </a-layout-header>
        <a-layout-content
          :style="{ overflow: 'initial',paddingTop:'64px' }"
        >
        <a-locale-provider :locale="zh_CN">
        <router-view/>
        </a-locale-provider>
        </a-layout-content>

          <a-layout-footer :style="{ textAlign: 'center'}">
            飞象宝 ©2020 万橡科技
          </a-layout-footer>
      </a-layout>
    </a-layout>
  </div>
</template>
<script>
import router from "@/router/index"
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';

moment.locale('zh-cn');
export default {
  name: 'home',
  data() {
    return {
      collapsed: false,
      left1:'200px',
      left2:'224px',
      zh_CN,

      defaultSelectedKeys: [this.$route.path],
      openKeys: [''],

      menulist:"",
      userinfo:""
    };
  },
  mounted(){
    this.$axios.get('/api/getLeftMenu',{
      headers:{
        "appid": this.appSet.appid,
        "appkey": this.appSet.appkey,
        "token":localStorage.getItem('token'),
      },
    }).then((res)=> {
      if(res.data.code==200){
        this.menulist=res.data.data
      }
    })

    this.$axios.get('/api/getuserself',{
      headers:{
        "appid": this.appSet.appid,
        "appkey": this.appSet.appkey,
        "token":localStorage.getItem('token'),
      },
    }).then((res)=> {
      if(res.data.code==200){
        this.userinfo=res.data.data
      }
    })
  },
  methods:{
    chang(){
      if(this.collapsed==false){
        this.collapsed=true
        this.left1='80px',
        this.left2='104px'
      }else{
        this.collapsed=false
        this.left1='200px',
        this.left2='224px'
      }
    },

    onOpenChange(openKeys) { 
      if (openKeys.length !== 0) {  
        this.openKeys = [openKeys[1]]
      } else {
        this.openKeys = ['']
      }
    },
  }
};
</script>
<style>
#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

#components-layout-demo-custom-trigger .trigger:hover {
  color: #1890ff;
}

#components-layout-demo-custom-trigger .logo {
  height: 32px;
  background: rgba(255, 255, 255, 0.2);
  margin: 16px;
}
</style>




// WEBPACK FOOTER //
// src/components/home.vue